import actions from 'modules/auditLog/auditLogActions';
import paginationReducer from 'modules/shared/pagination/paginationReducer';

export default paginationReducer(actions);
